<!-- Spinner -->

<!-- Content -->
@if (question && question.solutions !== undefined && trainingResult && trainingResult.answer !== undefined) {
  @if (question.solutions !== null && trainingResult.answer !== null && question.solutions.length === trainingResult.answer.length) {
    <!-- Header -->
    <medsurf-quiz-question-header [index]="((trainingSharedFacade.quizActive$ | async) ? undefined : question.customEnumeration) || (((trainingSharedFacade.selectedQuestionIndex$(question.id) | async) || index) + 1).toString()"
      [checkedAndCorrect]="trainingResult.showFeedback && isCorrect()"
      [questionType]="question.type">
    </medsurf-quiz-question-header>
    <!-- Question Form -->
    <form name="form"
      class="mdsf-quiz-form">
      <!-- Question Text -->
      <medsurf-text [text]="question.content"></medsurf-text>
      <!-- Choices -->
      @if ((trainingSharedFacade.typedQuestionChoicesOrder$ | async); as typedQuestionChoicesOrder) {
        @if ((trainingSharedFacade.choicesByIds$(typedQuestionChoicesOrder[question.id] || []) | async); as choices) {
          @if ((menuSharedFacade.showPrintForUser$ | async) === false) {
            <div class="mb-4">
              @for (solution of question.solutions; track solution; let j = $index) {
                <div class="mb-0 border-0 mt-0"
                  >
                  <div class="choice w-100 p-2"
                    [class.choice-error]="trainingResult.showFeedback && solution !== trainingResult.answer[j]"
                    [class.choice-correct]="trainingResult.showFeedback && solution === trainingResult.answer[j]"
                    [class.choice-not-answered]="showRequired && passItemRequired(j)">
                    <label class="mt-2 mr-2 align-middle text-black">{{ j + 1 }}.</label>
                    <div class="flex-grow-1">
                      <!-- User Answer -->
                      @if ((menuSharedFacade.showPrintForAuthor$ | async)) {
                        <select class="form-control custom-select">
                          <option>{{ getChoiceBySolution(choices, solution).label }}</option>
                        </select>
                      }
                      @if ((menuSharedFacade.showPrintForAuthor$ | async) === false) {
                        <select class="form-control custom-select"
                          [(ngModel)]="trainingResult.answer[j]"
                          [name]="'item' + question.order + 'set' + j"
                          [class.not-answered]="showRequired && passItemRequired(j)"
                          [required]="question.required"
                          [disabled]="trainingResult.showFeedback"
                          (change)="onChange()">
                          <option value="" disabled selected hidden>{{ question.placeholder }}</option>
                          @for (choice of choices; track choice; let k = $index) {
                            <option
                              [value]="choice.order">
                              {{ choice.label | stripTags }}
                            </option>
                          }
                        </select>
                      }
                      <!-- Correct Answer -->
                      @if (trainingResult.showFeedback && solution !== trainingResult.answer[j] && getChoiceBySolution(choices, solution); as choiceSolution) {
                        <div class="correct-answer mt-2"
                          >
                          <strong>{{ 'correct_answer' | translate }}:</strong> {{ choiceSolution.label | stripTags }}
                        </div>
                      }
                    </div>
                    <!-- Feedback -->
                    @if (trainingResult.showFeedback) {
                      <div class="form-control-feedback mt-2 ml-2"
                        [class.invisible]="trainingResult.showFeedback === false || trainingResult.answer[j] === ''">
                        @if (solution === trainingResult.answer[j]) {
                          <i class="fa fa-fw fa-check solution-correct"
                          ></i>
                        }
                        @if (solution !== trainingResult.answer[j]) {
                          <i class="fa fa-fw fa-times solution-error"
                          ></i>
                        }
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }
          <!-- Choices User Print Mode -->
          @if ((menuSharedFacade.showPrintForUser$ | async)) {
            <div class="mb-4"
              >
              @for (choice of choices; track choice) {
                <div class="mb-0 border-0 mt-0"
                  >
                  <div class="choice w-100 p-2">
                    <div class="print-radiobox"></div>
                    <div class="print-label">{{ choice.label | stripTags }}</div>
                  </div>
                </div>
              }
            </div>
          }
        } @else {
          <div class="d-flex justify-content-center m-2">
            <div class="spinner-border"></div>
          </div>
        }
      }
      <!-- Explanation -->
      @if (question.explanation && (trainingResult.showExplanation || (menuSharedFacade.showPrintForAuthor$ | async))) {
        <div class="form-control-explanation mt-2 "
          >
          <strong>{{ 'explanation' | translate }}</strong>
          <medsurf-text [text]="question.explanation"></medsurf-text>
        </div>
      }
      <!-- Footer -->
      @if ((menuSharedFacade.showPrint$ | async) === false && (question.solutions || []).length > 0) {
        <medsurf-quiz-question-footer #footer
          class="mt-2"
          [question]="question"
          [trainingResult]="trainingResult"
          [isCorrect]="isCorrect"
          [passRequired]="passRequired"
          [(showRequired)]="showRequired"
          [ngStyle]="{'order': 100}">
        </medsurf-quiz-question-footer>
      }
    </form>
  }
} @else {
  <div class="d-flex justify-content-center m-2">
    <div class="spinner-border"></div>
  </div>
}
